import { Heading, Link, Section } from 'components'
import { graphql } from 'gatsby'
import React from 'react'

const UpdatesArchive = ({
  data: {
    allWpProductUpdate: { nodes },
  },
  pageContext,
  location,
}) => {
  const { currentPage, numPostPages } = pageContext
  const isFirst = currentPage === 1
  const isLast = currentPage === numPostPages
  const prevPage = currentPage - 1 === 1 ? '' : (currentPage - 1).toString()
  const nextPage = (currentPage + 1).toString()

  return (
    <>
      <Section background="light" className="space-y-8">
        <div className="space-y-6 mb-16 text-center">
          <Heading type="kicker">Release Notes</Heading>
          <Heading>LeadBoxer Product Changes</Heading>
          <p className="text-xl">
            The most recent updates to the LeadBoxer product.
          </p>
        </div>

        <div className="col-span-8 space-y-8 max-w-4xl mx-auto">
          {nodes.map(({ title, id, content, slug, date }) => (
            <Section
              type="article"
              key={id}
              className="rounded-sm border border-gray-100 overflow-hidden"
              background="bg-white"
            >
              <div className="max-w-none space-y-6">
                <span className="text-gray-400 uppercase text-sm">{date}</span>
                <Heading level="3">
                  <Link
                    className="font-bold no-underline"
                    to={`/product-updates/${slug}`}
                  >
                    {title}
                  </Link>
                </Heading>

                <div dangerouslySetInnerHTML={{ __html: content }} />
              </div>
            </Section>
          ))}

          <div className="flex justify-between pt-8">
            <div>
              {!isFirst && (
                <Link to={`/product-updates/${prevPage}`} rel="prev">
                  ← Previous Page
                </Link>
              )}
            </div>
            <div>
              {!isLast && (
                <Link to={`/product-updates/${nextPage}`} rel="next">
                  Next Page →
                </Link>
              )}
            </div>
          </div>
        </div>
      </Section>
    </>
  )
}

export const query = graphql`
  query GET_UPDATES($skip: Int!, $limit: Int!) {
    allWpProductUpdate(
      sort: { order: DESC, fields: date }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        id
        slug
        title
        content
        date(formatString: "MMMM DD, YYYY")
      }
    }
  }
`

export default UpdatesArchive
